<template>
  <div class="main-container" style="background-color: #eff5fb">
    <Nav />
    <h1 style="text-align: center;width:100%">
      Deviz {{ this.IdDeviz != -1 ? "#" + this.IdDeviz : "" }}
    </h1>
    <!-- <pre>{{this.temp_list}}</pre> -->
    <div class="container-fluid list-container">
      <div class="title">
        <div v-if="editMode === true" class="container-fluid">
          <i
            class="el-icon-back"
            style="
              font-size: 25px;
              position: absolute;
              top: 60px;
              left: 4%;
              color: #6493c2;
              cursor: pointer;
            "
            @click="switch_mode()"
          ></i>
          <div class="category-container">
            <div v-for="prod in temp_produse" :key="prod.Id">
              <el-button @click="add_item(prod)" class="cat-btn" type="primary">
                {{ prod.Nume }}
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="editMode === false" class="category-container">
          <div v-for="cat in Categorii" :key="cat.Id">
            <el-button
              class="cat-btn"
              @click="switch_mode(cat.Id)"
              type="primary"
              >{{ cat.Nume }}</el-button
            >
          </div>
        </div>
        <div class="products-container">
          <div class="product-content">
            <!-- aici vine tabela -->
            <h4 style="text-align: center">Deviz</h4>
            <table class="table-list">
              <thead>
                <tr>
                  <th>Nume</th>
                  <th v-if="verifica_user()" style="text-align: right">Pret</th>
                  <th style="text-align: right">Cantitate</th>
                  <th v-if="verifica_user()" style="text-align: right">Valoare</th>
                </tr>
              </thead>

              <tbody v-for="(product, i) in temp_list" :key="product.Id + i">
                <tr>
                  <td>{{ product.Nume }}</td>
                  <td v-if="verifica_user()" style="text-align: right">
                    {{ (product.Pret * 1).toFixed(2) }} Ron
                  </td>
                  <td style="text-align: right">
                    <div class="amount-group">
                      <button @click="change_value(product, '-')" class="btn-amount" :disabled="verifica_drept_modificare_produs(product)">-</button>
                      <input class="input-number" v-model="product.Cantitate" type="number" :disabled="verifica_drept_modificare_produs(product)" >
                      <button @click="change_value(product, '+')" class="btn-amount" :disabled="verifica_drept_modificare_produs(product)">+</button>
                    </div>
                  </td>
                  <td v-if="verifica_user()" style="text-align: right"  >
                    {{ (product.Valoare * 1).toFixed(2) }} Ron
                  </td>
              
                  <td  width="7%" style="text-align: right">
                    <div
                      style="
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        justify-content: center;
                      "
                    >
                      <el-button
                      :disabled="verifica_drept_modificare_produs(product)"
                        type="danger"
                        @click="delete_item(i)"
                        class="list-btn"
                        >Sterge</el-button
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="" style="position: absolute; bottom: 0; margin-top: 10px">
        <h3 v-if="verifica_user()" style="text-align: center">
          Total:
          {{
            this.temp_list
              .map((prod) => Number(prod.Valoare))
              .reduce((p, i) => p + i, 0)
              .toFixed(2)
          }}
          Ron
        </h3>
        <div class="footer-btn">
         
          <el-button type="success" @click="save()">Salveaza</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- DE ELIMINAT -> AM TRANSFORMAT ACEASTA COMPONENTA INTR-UN DIALOG -> DE TESTAT PASTRAREA FUNCTIONALITATILOR -->
<script>
import BasePage from "@/pages/Admin/BasePage";
import Nav from "@/pages/Service/Devize/Nav.vue";
export default {
  name: "Programare",
  extends: BasePage,
  components: {
    Nav,
  },
  data() {
    return {
      IdDeviz: "",
      Categorii: undefined,
      Produse: undefined,
      Programare: undefined,
      editMode: false,
      temp_produse: undefined,
      temp_list: [{Id: '', Nume: '', Pret: '', Cantitate: '', Valoare: ''}],
    };
  },

  methods: {

    verifica_drept_modificare_produs(produs){

      return false;

      // if((this.$has_right('Mecanic') && produs.IdSupervizorAdaugare == '-1') ||
      //    (this.$has_right('Supervizor') && produs.IdSupervizorAdaugare > '0'))
      // {
      //   return false;
      //  }
      // return true
    },
    verifica_user() {

      if (this.$has_right('Mecanic')) return false;
      else return true;
      
    },

    change_value: async function(prod, mode) {

      // console.log(prod)
      if (mode === "+") {
          this.temp_list.find(p => p.Id === prod.Id).Cantitate++;
      } else {
          if (this.temp_list.find(p => p.Id === prod.Id).Cantitate <= 1) return;
          this.temp_list.find(p => p.Id === prod.Id).Cantitate--;
      }
      this.refresh_array(prod);
    },

    add_item: async function (prod) {

      if (this.temp_list.find(p => p.Id === prod.Id)) {
        var index = this.temp_list.findIndex(obj => {
          return obj.Id === prod.Id
        })
        this.$set(this.temp_list[index], 'Cantitate', Number(this.temp_list[index].Cantitate) + 1)
        this.$set(this.temp_list[index], 'Valoare', this.temp_list[index].Cantitate * this.temp_list[index].Pret)
        this.temp_list.splice( this.temp_list.length)
      } else {
        prod.Cantitate = 1;
        prod.Valoare   = prod.Pret;
        this.temp_list.unshift(prod);
      }

    },

    refresh_array: async function (product) {
      // console.log(product)
      if (product.Cantitate === "" || product.Cantitate.length < 0 || product.Cantitate < 0) product.Cantitate = 1;
      product.Valoare = product.Pret * product.Cantitate;
      this.temp_list.splice( this.temp_list.length);
    },
    delete_item: async function (index) {
      this.temp_list.splice(index, 1);
    },

    save: async function () {

      let res = await this.post("service/devize/save_produse_programare_deviz", {produse: this.temp_list, IdDeviz: this.IdDeviz});
      if(res.success == 1) {
        this.$message({ message: 'Devizul a fost salvat!', type: 'success' });
        this.$router.push({name: 'devize_draft'})
      } else {
        this.$message({ message: res.eroare, type: 'error' });  
      }

      


      // let res = await this.post("service/devize/save_produse_deviz", {produse: this.temp_list, idDeviz: this.IdDeviz});
      // if(res.success == 1) this.$message({ message: 'Devizul a fost salvat!', type: 'success' });

      // if(this.$has_right('Mecanic')) this.$router.push({name: 'devize_draft'})
      // if(this.$has_right('Supervizor')) this.$router.push({name: 'devize_in_lucru'})

      

    },

    deblocare_programare: async function(){
      let res = await this.post("service/devize/deblocare_programare", {IdDeviz: this.IdDeviz});
      if(res.success == 1) this.$message({ message: 'Programarea a fost deblocata!', type: 'success' });
    },
    blocare_programare: async function(){
      let res = await this.post("service/devize/blocare_programare", {IdDeviz: this.IdDeviz});
      if(res.success == 1) this.$message({ message: 'Programarea este blocata pana la inchiderea aceste ferestre. Doar Supervizorul poate prelua fortat aceasta comanda!', type: 'warning' });
    }

    ,switch_mode: async function (id) {
      if (!id) {
        this.temp_produse = undefined;
      } else {
        let res = await this.post("admin/produse/get_info_from_category", {  idCategorie: id, idDeviz: this.IdDeviz});
        let results = res.Result;
        this.temp_produse = results;
        // console.log(this.temp_produse);
      }

      this.editMode = !this.editMode;
    },
  },

  mounted: async function () {

    // if (!this.$has_right('Mecanic') && !this.$has_right('Supervizor')){
    //   this.$router.push('/no-rights')
    //   return
    // }
    this.IdDeviz = this.$route.params.id;


    let produse_existente_deviz = await this.post("service/devize/get_produse_deviz", {idDeviz: this.IdDeviz});

    if (produse_existente_deviz.deviz.length == 0 && !this.$has_right('Supervizor')){
      this.$message({ message: "Devizul este gol", type: 'error' });
      this.$router.push({name: 'devize_draft'})
    }
    

    var incearca_blocare = await this.post("service/devize/blocare_programare", {IdDeviz: this.IdDeviz});
    if (incearca_blocare.success == 1){
      if(produse_existente_deviz.produse_actualizate > 0) this.$message({ message: 'Au fost actualizate preturile pentru '+ produse_existente_deviz.produse_actualizate + ' produse', type: 'success' });
      this.temp_list = produse_existente_deviz.deviz;
    } else {
      this.$message({ message: incearca_blocare.error, type: 'error' });
      this.$router.push({name: 'devize_draft'})
    }

    let categorii = await this.post("categorii_produse/get_info_deviz", {idDeviz: this.IdDeviz});
    this.Categorii = categorii.Result;
    
    

    
  },
  async beforeRouteLeave (to, from, next) {
    await this.deblocare_programare();
    next()
  },
  async beforeDestroy() {
    await this.deblocare_programare();
	}
};
</script>

<style scoped>
.table-list {
  margin: 0;
  padding: 0;
  width: 100%;
}

.main-container {
  max-height: 100vh;
  overflow: hidden;
}

.list-btn {
  width: 70px;
  padding: 3px 15px;
  text-align: center;
  font-size: 10px;
  height: 21px;
}

.category-container {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 16vh;
  overflow: hidden;
  overflow-y: scroll;
}
.list-container {
  margin: 0;
  padding: 15px 5px;
  width: 100% !important;

  display: flex;
  justify-content: center;
  background-color: #eff5fb;
  gap: 5px;
  flex-wrap: wrap;
  overflow: hidden;
  overflow-y: scroll;
  min-height: 100vh;
}

.products-container {
  position: relative;
  margin: 0;
  padding: 10px;
  width: 80%;
  max-height: 50vh;
  overflow: scroll;
  margin-top: 50px;
  border-radius: 4px;
  background-color: #dde9f5;
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 1.3rem;
}

.product-content {
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background-color: #dde9f5;
  max-height: 100%;
}

.product-title {
  height: 60px;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  width: 100%;
  height: 10vh;
}

.cat-btn {
  background-color: #6493c2;
  border-color: #6493c2;
  min-width: 30vw;
  height: 42px;
  margin: 0px;
  padding: 7px;
  font-size: 1.2rem;
}



.footer-container {
  min-height: 100%;
  margin: 0;
  padding: 0;
  width: 80%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.amount-group {
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

}

.btn-amount {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 20px;
  border: none;
  width: 25px;
  background-color: transparent;
}

.input-number {
  background: transparent;
  text-align: center;
  width: 15%;
  font-size: 15px;
  height: 100%;
  border: none;
  padding: 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input:focus {
    outline: none !important;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media only screen and (max-width: 700px) {
  /* Pentru telefon: */

  .input-number {
    width: 30%;

  }

  .btn-amount {
    font-size: 15px;
    width: 20px;

  }

  .main-container {
    max-height: 100vh;
    overflow: hidden;
  }

  .footer-container {
    width: 86%;
  }

  .list-container {
    max-height: 90vh;
  }

  .title {
    width: 100%;
    height: 10vh;
  }

  .category-container {
    position: relative;
    display: flex;
    justify-content: space-evenly;
    max-height: 16vh;
  }
  .products-container {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 40vh;
    overflow: auto;
    width: 90%;
    font-size: 0.9rem;
  }

  .footer-btn {
    margin: 0;
    padding: 0;
    justify-content: center;

  }

  .footer-btn .el-button {
    width: 100px;
    text-align: center;
    font-size: 10px;
  }

  .cat-btn {
    text-align: center;
    background-color: #6493c2;
    border-color: #6493c2;
    width: 40vw;
    min-height: 42px;
    height: auto;
    font-size: 3.5vw;
    white-space: normal;
    word-wrap: break-word;
  }
}

.footer-btn {
  display: flex;
  justify-content: center;
}


</style>